import React, { memo } from 'react';
import cc from 'classcat';
import { NUMBER_LIST_TYPE, type NumberListType } from '../../constants';
import NumberItem from './components/NumberItem';

interface NumberItemObject {
  value?: number | null;
  seat?: number | null;
  border?: boolean;
  isTaken?: boolean;
  multiplier?: number;
}

interface NumberListProps {
  numbers: (number | NumberItemObject)[];
  type?: NumberListType;
  maxLength?: number;
}

const NumberList: React.FC<NumberListProps> = ({ numbers = [], type = null, maxLength = 8 }) => {
  const classes = cc([
    'numberItems',
    type === NUMBER_LIST_TYPE.BLACKJACK && 'numberItems--blackjack',
    type === NUMBER_LIST_TYPE.ROULETTE && 'numberItems--roulette',
    type === NUMBER_LIST_TYPE.UNIFORM_SQUARES && 'numberItems--uniform'
  ]);

  return (
    <div className={classes}>
      {Array.isArray(numbers) &&
        numbers.slice(0, maxLength).map((numberItem, i) => {
          if (typeof numberItem === 'object' && numberItem !== null) {
            const withBorder =
              numberItem.border ||
              (i === 0 && type === NUMBER_LIST_TYPE.ROULETTE) ||
              (i === 0 && type === NUMBER_LIST_TYPE.UNIFORM_SQUARES) ||
              (type === NUMBER_LIST_TYPE.BLACKJACK && !numberItem.isTaken);
            const bonus =
              numberItem.multiplier && numberItem.multiplier > 0
                ? String(numberItem.multiplier)
                : '';

            return (
              <NumberItem
                // eslint-disable-next-line react/no-array-index-key -- no unique key available for these items
                key={i}
                border={withBorder}
                opaque={numberItem.isTaken}
                bonus={bonus}
                number={numberItem.value ?? numberItem.seat ?? null}
                type={type}
              />
            );
          }

          const withBorder =
            (i === 0 && type === NUMBER_LIST_TYPE.ROULETTE) ||
            (i === 0 && type === NUMBER_LIST_TYPE.UNIFORM_SQUARES);
          return (
            <NumberItem
              number={numberItem}
              border={withBorder}
              // eslint-disable-next-line react/no-array-index-key -- no unique key available for these items
              key={i}
              type={type}
            />
          );
        })}
    </div>
  );
};

export default memo(NumberList);
